// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"d96d52b3","439":"d96d52b3","565":"d96d52b3"}[chunkId] + ".chunk.css";
};